import React, { useState } from 'react';
import { webApi } from '../services/api';
import { AppHeader, StatusBanner } from '../components/ui';

function GstVerificationPage() {
  const [gstin, setGstin] = useState('');
  const [referenceId, setReferenceId] = useState('');
  const [message, setMessage] = useState('');

  const verify = async (event) => {
    event.preventDefault();
    try {
      const data = await webApi.verifyGstin({ gstin });
      setReferenceId(data?.referenceId || '');
      setMessage('GSTIN verified successfully');
    } catch (err) {
      setMessage(err.message || 'GSTIN verification failed');
    }
  };

  const link = async (event) => {
    event.preventDefault();
    try {
      await webApi.linkGstin({ reference_id: referenceId, confirm: true });
      setMessage('GSTIN linked successfully');
    } catch (err) {
      setMessage(err.message || 'GSTIN link failed');
    }
  };

  return (
    <div className="page">
      <AppHeader title="GST Verification" subtitle="Verify and link GSTIN for employer profile." />
      <StatusBanner kind={message.toLowerCase().includes('fail') ? 'error' : 'success'} message={message} />
      <div className="form-grid">
        <form className="stack card" onSubmit={verify}>
          <h3 className="section-title">Verify GSTIN</h3>
          <input value={gstin} onChange={(e) => setGstin(e.target.value.toUpperCase())} placeholder="GSTIN" required />
          <button type="submit" className="btn btn-primary">Verify</button>
        </form>
        <form className="stack card" onSubmit={link}>
          <h3 className="section-title">Link Verified GSTIN</h3>
          <input value={referenceId} onChange={(e) => setReferenceId(e.target.value)} placeholder="Reference ID" required />
          <button type="submit" className="btn btn-primary">Link GSTIN</button>
        </form>
      </div>
    </div>
  );
}

export default GstVerificationPage;
